import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function fetchProps(params = {}) {
  const { data } = await api.get("/props", { params });
  return data;
}

export async function fetchPropById(id) {
  const { data } = await api.get(`/props/${id}`);
  return data;
}

export async function fetchPlayer(id) {
  const { data } = await api.get(`/players/${id}`);
  return data;
}

export async function fetchSummary() {
  const { data } = await api.get("/stats/summary");
  return data;
}

export async function fetchWatchlist(token) {
  const { data } = await api.get(`/watchlist/${token}`);
  return data;
}

export async function toggleWatchlist(token, propId) {
  const { data } = await api.post(`/watchlist`, {
    user_token: token,
    prop_id: propId,
  });
  return data;
}

export function getUserToken() {
  let t = localStorage.getItem("pe_user_token");
  if (!t) {
    t = "anon_" + Math.random().toString(36).slice(2, 10);
    localStorage.setItem("pe_user_token", t);
  }
  return t;
}
